import styled from "styled-components"

interface IconWrapperProps {
  archived: boolean
}

export const IconWrapper = styled.div<IconWrapperProps>`
  img {
    width: 25px;
    height: 25px;
    ${({archived}) => archived && "opacity: .3;"}
  }
`
